import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const queryTotal = dictQuery => {
  const $0 = dictQuery.queryImpl(Restaumatic$dForm$dQuery.Lax);
  return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toTotal)($0(x));
};
const readTotal = dictMonadEffect => dictQuery => {
  const $0 = queryTotal(dictQuery);
  return x => Specular$dFRP$dBase.readDynamic(dictMonadEffect)($0(x));
};
export {queryTotal, readTotal};
